// Javascript's native modulo operator can return negative values
var remainder = function remainder(dividend, divisor) {
  return (dividend % divisor + divisor) % divisor;
};

export default remainder;